// extracted by mini-css-extract-plugin
export default {"body":"SMLUpgradeBody_body__ZFYWQ","lead":"SMLUpgradeBody_lead__lEOJq","head":"SMLUpgradeBody_head__ZUR4E","title":"SMLUpgradeBody_title__-tQ9R","lede":"SMLUpgradeBody_lede__nTEdB"};